import React, {Fragment} from 'react'
import {connect} from 'react-redux'
import {func, oneOf} from 'prop-types'

import {isModeOneOf} from '../login.helper'
import {loginModes, loginModesList} from '../helpers/login.data'

import Username from './username/username.presenter'
import Password from './password/password.presenter'
import ConfirmPassword from './confirmPassword/confirmPassword.presenter'
import TFACode from './tfaCode/tfaCode.presenter'
import Audit from './audit/audit.presenter'
import PasswordRequirements from './passwordRequirements/passwordRequirements.presenter'

const {
  createNewPassword,
  renewExpiredPassword,
  normal,
  forgotPasswordEmailSent,
  tfaCode,
  audit,
  newUserLinkExpired
} = loginModes

const PasswordFields = ({mode, onSubmit}) => (
  <Fragment>
    <Username
      onSubmit={onSubmit}
      isVisible={!isModeOneOf({mode, modes: [forgotPasswordEmailSent, audit, newUserLinkExpired]})}
    />
    {(isModeOneOf({mode, modes: [createNewPassword, renewExpiredPassword]})) && (
      <PasswordRequirements />
    )}
    <Password
      onSubmit={onSubmit}
      isVisible={isModeOneOf({mode, modes: [normal, createNewPassword, renewExpiredPassword]})}
    />
    <ConfirmPassword
      onSubmit={onSubmit}
      isVisible={isModeOneOf({mode, modes: [createNewPassword, renewExpiredPassword]})}
    />
    <TFACode
      onSubmit={onSubmit}
      isVisible={mode === tfaCode}
    />
    <Audit
      onSubmit={onSubmit}
      isVisible={isModeOneOf({mode, modes: [audit]})}
    />
  </Fragment>
)

const mapStateToProps = ({loginReducer}) => ({
  mode: loginReducer.mode
})

const mapDispatchToProps = () => ({})

PasswordFields.propTypes = {
  mode: oneOf(loginModesList),
  onSubmit: func.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordFields)
